import { peekGymCache } from '../services/cache/gymCache';

export function instantLoadState(cacheKey, fallback = []) {
  const cached = peekGymCache(cacheKey);
  return {
    initialData: cached ?? fallback,
    initialLoading: cached == null,
  };
}
